import React, { Children, useState } from "react";
import { Form, InputNumber, message, Popover, theme } from "antd";
import { URL_TRUCK } from "../../constants/urls";
import { PATCH } from "../../frameworks/HttpClient";
import ColorButton from "../../common/ColorButton";

export default function(props){
  const {target, onUpdate, children} = props;
  const [form] = Form.useForm(); 
  const [visible, setVisible] = React.useState(false);
  const [messageApi, contextHolder] = message.useMessage();
  // ฟังก์ชันเปิด/ปิด Popover
  const handleVisibleChange = (newVisible) => {
    setVisible(newVisible);
  };

  const handleOK = async() => {
    try {
      const data = await form.validateFields();
      data["truck_transaction"] = target;
      await PATCH(`${URL_TRUCK.TRUCK_TRANSACTION}${target}/`, data);
      onUpdate();
      setVisible(false)
    } catch (error) {
      if (error.errorMessages) {
        messageApi.error({ content: error.errorMessages });
      }
    }
  }

  const { token : { colorWarning }} = theme.useToken();

  return (
    <div>
      {contextHolder}
      <Popover 
        title={<center>{"ใส่ค่า %DRC"}</center>}
        trigger="click"
        open={visible}
        onOpenChange={handleVisibleChange}
        style={{ padding : 5} }
        content={ 
          <Form
            form={form}
            layout={'vertical'}
            style={{ width: "100%"}}
            autoComplete="off">
              <Form.Item
                name={"drc"}
                style={{ alignItems: 'center',  justifyContent: 'center', display: 'flex' }}
                rules={[{ required: true, message: 'กรุณากรอกข้อมูล' }]}>
                  <InputNumber autoComplete="off" style={{ width: 300 }} placeholder="DRC%" addonBefore="DRC" addonAfter="%" onPressEnter={() => handleOK()}/>
              </Form.Item>
              <Form.Item>
                <ColorButton type={"primary"} override={colorWarning} onClick={handleOK} style={{ float : 'right'}}>แก้ไข</ColorButton>
                <ColorButton onClick={() => setVisible(false)} style={{ float : 'right', marginRight : 5 }}>ปิด</ColorButton>
              </Form.Item>
          </Form>
        }
      >
        {children}
      </Popover>
    </div>
  )
}